const _API_VERSIONS = ['1', '2'];
const _SCHEMA_VERSIONS = ['oafv1'];
export const API_VERSIONS = _API_VERSIONS;
export const SCHEMA_VERSIONS = _SCHEMA_VERSIONS;
export const SCHEMA_VERSION = 'oafv1';
export const NEXT_SCHEMA_VERSION = 'oafv1';
export const SCHEMA_VERSION_QUERY_PARAM = 'schemaVersion'; // for API v1 backwards compatibility
export const SCHEMA_VERSION_HEADER = 'SchemaVersion';
export const BASE_PUBLISHER_FIELD_NAMES = {
    ID: 'id',
    EXTERNAL_ID: 'external_id',
    NAME: 'name',
    EXTENSIONS: 'extensions',
};
// Base Listing Field Names to be used in tests/other modules
export const BASE_LISTING_FIELD_NAMES = {
    ID: 'id',
    NAME: 'name',
    TECH_TYPE: 'technology',
    PUBLIC: 'public',
    PLUGINS: 'plugins',
    EXTENSIONS: 'extensions',
};
// Extension Field Names on the Base Listing
export const EXTENSION_FIELD_NAMES = {
    EXTENSION_TYPE: 'extensionType',
    DATA: 'data',
};
// Plugin Field Names on the Base Listing
export const PLUGIN_FIELD_NAMES = {
    PLUGIN_TYPE: 'pluginType',
    DATA: 'data',
};
//# sourceMappingURL=schemas_config.js.map